import { ErrorType } from "./apiHelpers";
import { ILog, getToken } from "helpers";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";

// Define a service using a base URL and expected endpoints
export const logApi = createApi({
  reducerPath: "logApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/auth/user/logs`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLogs: builder.query<ILog[] | any, string>({
      query: (username: string) => ({
        url: `list/${username}`,
      }),
      transformErrorResponse: (error: any) => error.data.apierror as ErrorType,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetLogsQuery, useLazyGetLogsQuery, usePrefetch: useLogApiPrefetch } = logApi;
